// Toast wrapper to maintain react-hot-toast API compatibility
let toastInstance = null;
let pendingCalls = [];

export const setToastInstance = (instance) => {
  toastInstance = instance;
  // Process any pending calls
  while (pendingCalls.length > 0) {
    const call = pendingCalls.shift();
    call();
  }
};

const toast = (message, options = {}) => {
  if (!toastInstance) {
    pendingCalls.push(() => toastInstance.default(message, options));
    return;
  }
  return toastInstance.default(message, options);
};

// Add the same methods as react-hot-toast
toast.success = (message, options = {}) => {
  if (!toastInstance) {
    pendingCalls.push(() => toastInstance.success(message, options));
    return;
  }
  return toastInstance.success(message, options);
};

toast.error = (message, options = {}) => {
  if (!toastInstance) {
    pendingCalls.push(() => toastInstance.error(message, options));
    return;
  }
  return toastInstance.error(message, options);
};

toast.warning = (message, options = {}) => {
  if (!toastInstance) {
    pendingCalls.push(() => toastInstance.warning(message, options));
    return;
  }
  return toastInstance.warning(message, options);
};

toast.info = (message, options = {}) => {
  if (!toastInstance) {
    pendingCalls.push(() => toastInstance.info(message, options));
    return;
  }
  return toastInstance.info(message, options);
};

export default toast;
